<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title>{{title}}</h1>
    <div fxFlex>
        <p [innerHTML]="message | safeHTML"></p>
        <form [formGroup]="ReportOptionsForm" novalidate fxLayout="row" fxLayoutAlign="start start" fxLayoutGap.gt-sm="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
            <mat-form-field floatPlaceholder="never">
                <mat-select *ngIf="ReportInfo.CanSetSchool === true" formControlName="ReportSchool" aria-label="School selection list" placeholder="Select school...">
                    <mat-option *ngFor="let school of AvailableSchools" [value]="school">{{school.SchoolName}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field floatPlaceholder="never">
                <mat-select formControlName="ReportCollege" aria-label="College selection list" placeholder="Select college...">
                    <mat-option *ngFor="let col of AvailableColleges" [value]="col">{{col.CollegeName}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field floatPlaceholder="never">
                <mat-select formControlName="ReportTerm" aria-label="College term selection list" placeholder="Select term...">
                    <ng-container *ngIf="ReportCollege.value">
                        <mat-option *ngFor="let term of ReportCollege.value.Terms" [value]="term">{{term.CollegeSchoolYear | collegeSchoolYear:ReportCollege.value.CollegeID}} - {{term.TermCode | collegeTerm}} (Term {{term.TermCode}})</mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>
        </form>
    </div>
    <mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
        <button color="primary" mat-raised-button (click)="OkHandler()" [disabled]="ReportOptionsForm.invalid"><span [innerHTML]="oktext | safeHTML"></span></button>
        <button color="warn" mat-raised-button (click)="CancelHandler()"><span [innerHTML]="canceltext | safeHTML"></span></button>
    </mat-dialog-actions>
</div>



// WEBPACK FOOTER //
// ./src/services/dialogs/reportoptions/reportoptions.dialogcomponent.html